import { render, staticRenderFns } from "./TeamLogo.vue?vue&type=template&id=66296e8f&"
import script from "./TeamLogo.vue?vue&type=script&lang=js&"
export * from "./TeamLogo.vue?vue&type=script&lang=js&"
import style0 from "./TeamLogo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeamLogo.vue"
export default component.exports